import { useLocation } from 'react-router-dom';
import { useSite } from '../hooks/useSite';
import { PAGE, slugOf } from '../lib/content';
import PageMeta from '../components/PageMeta';
import { ContentError } from '../components/Primitives';
import HomePage from './HomePage';
import EducationPage from './EducationPage';
import ServicesOverviewPage from './ServicesOverviewPage';
import ServicePage from './ServicePage';
import PricesPage from './PricesPage';
import AboutPage from './AboutPage';
import BookingPage from './BookingPage';
import TalkPage from './TalkPage';
import LegacyPage from './LegacyPage';
import ErrorPage from './ErrorPage';

const serviceIds = new Set([PAGE.grooming, PAGE.osteopathy, PAGE.massage, PAGE.craniosacral]);

export default function PageResolver() {
  const { pathname } = useLocation();
  const { pagesLoading, pagesError, retryPages, pageByPath, pageById } = useSite();
  const matched = pageByPath(pathname);
  if (pagesLoading && !matched) return <div className="min-h-[70vh] animate-pulse bg-cream" aria-label="Indlæser siden" />;
  if (pagesError && !matched) return <ContentError onRetry={retryPages} />;

  const page = matched || pageById(PAGE.notFound);
  if (!page) return <ContentError onRetry={retryPages} />;
  const id = slugOf(page);
  let body;
  if (!matched || id === PAGE.notFound) body = <ErrorPage page={page} code="404" />;
  else if (id === PAGE.forbidden) body = <ErrorPage page={page} code="403" />;
  else if (id === PAGE.home) body = <HomePage page={page} />;
  else if (id === PAGE.education) body = <EducationPage page={page} />;
  else if (id === PAGE.treatments) body = <ServicesOverviewPage page={page} />;
  else if (serviceIds.has(id)) body = <ServicePage page={page} />;
  else if (id === PAGE.prices) body = <PricesPage page={page} />;
  else if (id === PAGE.about) body = <AboutPage page={page} />;
  else if (id === PAGE.booking) body = <BookingPage page={page} />;
  else if (id === PAGE.talk) body = <TalkPage page={page} />;
  else if (page.source_url) body = <LegacyPage page={page} />;
  else body = <ErrorPage page={pageById(PAGE.notFound)} code="404" />;

  return <><PageMeta page={page} />{body}</>;
}
